<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <!-- 사업장 -->
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-datepicker
            :range="true"
            defaultStart="-6M"
            defaultEnd="0M"
            label="기간"
            name="period"
            v-model="searchParam.period"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-fire-fighting
            label="관련 소방설비"
            name="sopFireFightingId"
            v-model="searchParam.sopFireFightingId">
          </c-fire-fighting>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-text
            label="중계기 종류"
            name="repeaterType"
            v-model="searchParam.repeaterType">
          </c-text>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-text
            label="제조사"
            name="repeaterMenufCompany"
            v-model="searchParam.repeaterMenufCompany">
          </c-text>
        </div>
      </template>
    </c-search-box>
    <c-table
      ref="table"
      title="소방 화재수신기 작동 이력 목록"
      :columns="grid.columns"
      :data="grid.data"
      @linkClick="linkClick"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline >
          <c-btn v-if="editable" label="LBLREG" icon="add" @btnClicked="openPop" />
          <c-btn label="LBLSEARCH" icon="search" @btnClicked="getList" />
        </q-btn-group>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'fireFightingReceivingSetHistory',
  data() {
    return {
      searchParam: {
        plantCd: null,
        period: [],
        sopFireFightingId: null,
        repeaterType: '',
        repeaterMenufCompany: '',
      },
      grid: {
        columns: [
          {
            name: 'plantName',
            field: 'plantName',
            label: 'LBLPLANT',
            align: 'center',
            sortable: true,
            style: 'width: 100px',
          },
          {
            name: 'reportDate',
            field: 'reportDate',
            label: '보고일',
            align: 'center',
            sortable: true,
            style: 'width: 100px',
          },
          {
            name: 'fireFightingGroupName',
            field: 'fireFightingGroupName',
            label: '소방설비',
            align: 'left',
            sortable: true,
            style: 'width: 250px',
            type: 'link'
          },
          {
            name: 'repeaterType',
            field: 'repeaterType',
            label: '중계기 종류',
            align: 'left',
            sortable: true,
            style: 'width: 150px',
          },
          {
            name: 'repeater',
            field: 'repeater',
            label: '중계기 번호',
            align: 'center',
            sortable: true,
            style: 'width: 100px',
          },
          {
            name: 'repeaterMenufCompany',
            field: 'repeaterMenufCompany',
            label: '제조사',
            align: 'left',
            sortable: true,
            style: 'width: 150px',
          },
          {
            name: 'location',
            field: 'location',
            label: '장소',
            align: 'center',
            sortable: true,
            style: 'width: 300px',
          },
        ],
        data: [],
      },
      editable: true,
      listUrl: '',
      popupOptions: {
        isFull: true,
        target: null,
        title: '',
        visible: false,
        top: '',
        param: {},
        closeCallback: null,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.fft.fireFightingReceivingSetHistory.list.url
      // code setting
      // list setting
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    linkClick(row) {
      this.openPop(row);
    },
    openPop(row) {
      this.popupOptions.title = '소방 화재수신기 작동 이력 보고';
      this.popupOptions.param = {
        sopFireFightingReceivingSetHistoryId: row ? row.sopFireFightingReceivingSetHistoryId : '',
      };
      this.popupOptions.target = () => import(`${'./fireFightingReceivingSetHistoryDetail.vue'}`);
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
  }
};
</script>
